var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.progressFlag,
          expression: "progressFlag",
        },
      ],
      staticClass: "dsf-readfilestructure",
    },
    [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "title" }, [
            _c(
              "div",
              { staticClass: "path" },
              [
                _c("i", { staticClass: "iconfont icon-wenjianjia" }),
                _c("el-input", {
                  attrs: { placeholder: "路径", clearable: "", readonly: "" },
                  model: {
                    value: _vm.rootPath,
                    callback: function ($$v) {
                      _vm.rootPath = $$v
                    },
                    expression: "rootPath",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "btns" },
              [
                _c(
                  "dsf-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { icon: "add", title: "创建文件夹" },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = true
                      },
                    },
                  },
                  [_vm._v("新建文件夹")]
                ),
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      action: _vm.dsf.url.getWebPath(_vm.uploadFileUrl),
                      "file-list": _vm.fileList,
                      "http-request": _vm.httpRequest,
                      "on-success": _vm.handleSuccess,
                      "on-error": _vm.handleError,
                      "on-change": _vm.handleChange,
                      disabled: _vm.progressFlag,
                    },
                  },
                  [
                    _c(
                      "dsf-button",
                      {
                        attrs: {
                          title: "上传文件",
                          icon: "shangchuan",
                          disabled: _vm.progressFlag,
                        },
                      },
                      [_vm._v("上传文件")]
                    ),
                  ],
                  1
                ),
                _vm.showProgress
                  ? _c(
                      "div",
                      { staticClass: "progress" },
                      [
                        _c("el-progress", {
                          attrs: {
                            id: "progress",
                            type: "circle",
                            percentage: _vm.percent,
                            "stroke-width": 8,
                            width: 100,
                            "show-text": true,
                            "stroke-linecap": "round",
                            format: _vm.progressFormat,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                height: "500",
                border: "",
                stripe: "",
                data: _vm.tableData,
              },
            },
            [
              _c("el-table-column", {
                key: "name",
                attrs: {
                  width: "auto",
                  label: "名称",
                  align: "left",
                  prop: "name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: { folder: scope.row.dir },
                            on: {
                              click: function ($event) {
                                return _vm.loadNextFile(scope.row)
                              },
                            },
                          },
                          [
                            scope.row.dir
                              ? _c("i", {
                                  staticClass: "iconfont icon-wenjianjia",
                                })
                              : _vm._e(),
                            _vm._v(" " + _vm._s(scope.row.name) + " "),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                key: "size",
                attrs: {
                  width: "auto",
                  label: "大小",
                  align: "left",
                  prop: "size",
                },
              }),
              _c("el-table-column", {
                key: "type",
                attrs: {
                  width: "auto",
                  label: "类型",
                  align: "left",
                  prop: "type",
                },
              }),
              _c("el-table-column", {
                key: "modifyTime",
                attrs: {
                  width: "auto",
                  label: "修改时间",
                  align: "left",
                  prop: "modifyTime",
                },
              }),
              _c("el-table-column", {
                key: "path",
                attrs: {
                  width: "auto",
                  label: "路径",
                  align: "left",
                  prop: "path",
                },
              }),
              _c("el-table-column", {
                key: "owner",
                attrs: {
                  width: "auto",
                  label: "owner",
                  align: "left",
                  prop: "owner",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "新建文件夹",
            modal: false,
            visible: _vm.dialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "directory",
              attrs: {
                model: _vm.directory,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "文件夹名称:", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.directory.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.directory, "name", $$v)
                      },
                      expression: "directory.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "dsf-button",
                { attrs: { title: "确定" }, on: { click: _vm.confirm } },
                [_vm._v("确 定")]
              ),
              _c(
                "dsf-button",
                {
                  attrs: { type: "plain", title: "取消" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }